import React from 'react';
import ReactDOM from 'react-dom';
// import apf_big_logo from '../../../../images/auth/APF-Big-Logo.png';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(255, 255, 255, 1)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 99999,
  pointerEvents: 'auto',
};

const loadingTextStyle = {
//   color: '#0d6efd',  // bootstrap's text-primary color
  fontSize: '2rem',
  marginTop: '20px',
  fontWeight: 'bold',
};

const imageStyle = {
  width: '150px',   // increased size
  height: 'auto',
};

const LoadingOverlay = ({ loading }) => {
  if (!loading) return null;

  return ReactDOM.createPortal(
    <div style={overlayStyle}>
      {/* <img src={apf_big_logo} alt="Loading logo" style={imageStyle} /> */}
      <div className="spinner-border text-primary mt-3" role="status" style={{ width: '4rem', height: '4rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
      <div className='text-danger' style={loadingTextStyle}>Loading...</div>
    </div>,
    document.body
  );
};

export default LoadingOverlay;
